import ContentBox from 'components/checkout/caap/ContentBox';
import GiftCardContainer from 'components/checkout/caap/GiftCardContainer';

const AddGiftCardMobile = componentParams => {
  const {
    constraintViolations,
    giftCards,
    isFetchingCheckoutData,
    onGiftCardChange,
    onGiftCardVerify,
    onToggleGiftCardModalClick
  } = componentParams;

  return (
    <ContentBox
      isLast={true}
      isNonRadio={true}
      showOnlySmallScreen={true}>
      <GiftCardContainer
        code={giftCards.code || ''}
        constraintViolations={constraintViolations}
        isFetchingCheckoutData={isFetchingCheckoutData}
        onGiftCardChange={onGiftCardChange}
        onGiftCardVerify={onGiftCardVerify}
        onToggleGiftCardModalClick={onToggleGiftCardModalClick}
        showGiftCardModal={giftCards.showModal}
      />
    </ContentBox>
  );
};

export default AddGiftCardMobile;
